/* eslint-disable react/jsx-sort-props */

/**
 * DO NOT MODIFY THIS ICON DIRECTLY.
 *
 * THIS ICON WAS AUTOMATICALLY GENERATED.
 * SVG RETRIEVED FROM SPRING FOUNDATIONS FIGMA FILE.
 * @see https://www.figma.com/design/kcg95u086DD7Sa9or8Bwpq/%F0%9F%8C%B1--Foundations---Spring-2.0?node-id=24-2&p=f&t=75lUXy0FPOr0htKP-0
 */
import React from 'react';

import {Icon as BaseIcon, type BaseIconProps} from './Icon/Icon';
import {IconComponent} from './types';

export const UserDeleteIcon = React.forwardRef<HTMLDivElement, BaseIconProps>(
  ({size = 16, ...props}, ref) => {
    return (
      <BaseIcon {...props} size={size} ref={ref}>
        <svg
          data-wf-icon="UserDeleteIcon"
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g>
            <g>
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8 2C6.34315 2 5 3.34315 5 5C5 6.65685 6.34315 8 8 8C9.65685 8 11 6.65685 11 5C11 3.34315 9.65685 2 8 2ZM6 5C6 3.89543 6.89543 3 8 3C9.10457 3 10 3.89543 10 5C10 6.10457 9.10457 7 8 7C6.89543 7 6 6.10457 6 5Z"
                fill="currentColor"
              />
              <path
                d="M3 11.5C3 10.6716 3.67157 10 4.5 10H8V9H4.5C3.11929 9 2 10.1193 2 11.5V13H3V11.5Z"
                fill="currentColor"
              />
              <path
                d="M11.5 12.2071L9.85355 13.8536L9.14645 13.1464L10.7929 11.5L9.14645 9.85355L9.85355 9.14645L11.5 10.7929L13.1464 9.14645L13.8536 9.85355L12.2071 11.5L13.8536 13.1464L13.1464 13.8536L11.5 12.2071Z"
                fill="currentColor"
              />
            </g>
          </g>
        </svg>
      </BaseIcon>
    );
  }
) as IconComponent;

UserDeleteIcon.tags = ['user', 'delete', 'remove', 'account', 'profile'];

UserDeleteIcon.category = 'General Icons';

UserDeleteIcon.iconSize = 16;
